export const getStageName = (stage) => {
  if (![1, 3, 4, 5, 6].includes(stage)) return null;

  return {
    1: 'opportunity',
    3: 'positive',
    4: 'negative',
    5: 'follow_up',
    6: 'negociacao',
  }[stage]
}